export const trim = (value) => {
    return (value || '').trim();
};
